const ENV = window?.baseo?.comarquage

export { ENV }
